import useMeowLightboxContext from "../context";
import { useController } from "../helpers";
import { Actions } from "./actions";
import { Counter } from "./counter";

export const MeowLightboxTopbar = ({ className }) => {

  const { image } = useMeowLightboxContext();
  const { onCloseClick } = useController();
  if (!image) {
    return null;
  }

  return (
    <div className={className} onClick={onCloseClick}>
      <div className="mwl__topbar__slide-counter">
        <Counter />
      </div>
      <div className="mwl__topbar__controls">
        <Actions />
      </div>
    </div>
  );
};
